import isomorphicFetch from 'isomorphic-fetch'

export const fetch = isomorphicFetch
